import React, { useState } from "react";
import { Box, Typography, List, ListItem, ListItemText, IconButton } from "@mui/material";
import { errorMessage } from "../../helpers/errorMessageFunc";
import CloseIcon from "@mui/icons-material/Close";

const TxtUpload = (props) => {
  const [fileList, setFileList] = useState([]);

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);

    // Only allow text files and limit to 5
    const validFiles = files
      .filter((file) => file.type === "text/plain" || (file.type === "" && file.name.endsWith('.bai')))
      .slice(0, 5 - fileList.length);

    if (validFiles.length < files.length) {
      errorMessage("Only valid .txt files are allowed or maximum limit is 5.");
    }

    const readerPromises = validFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          resolve({ name: file.name, body: e.target.result });
        };
        reader.onerror = reject;
        reader.readAsText(file);
      });
    });

    Promise.all(readerPromises)
      .then((fileObjects) => {
        setFileList((prevFiles) => [...prevFiles, ...fileObjects]);
        props.setTxtData((prevData) => [...prevData, ...fileObjects]);
      })
      .catch(() => {
        errorMessage("Error reading file content.");
      });
  };

  const handleDragOver = (event) => {
    event.preventDefault(); // Allow drop
  };

  const handleRemoveFile = (fileIndex) => {
    const updatedFileList = [...fileList];
    const updatedFileContents = [...props.txtData];

    // Remove the clicked file
    updatedFileList.splice(fileIndex, 1);
    updatedFileContents.splice(fileIndex, 1);

    setFileList(updatedFileList);
    props.setTxtData(updatedFileContents);
  };

  return (
    <Box>
      {/* Drag & Drop Area */}
      <Box
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        sx={{
          border: "2px dashed #aaa",
          borderRadius: "8px",
          height: "200px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          cursor: "pointer",
          p: 2,
          "&:hover": {
            borderColor: "#555",
          },
        }}
      >
        <Typography variant="body1" sx={{ color: "#555" }}>
          Drag and drop up to 5 BAI2 files.
        </Typography>
      </Box>

      {/* List of Dropped Files */}
      {fileList.length > 0 && (
        <>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Uploaded Files
          </Typography>
          <List>
            {fileList.map((fileObj, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1,
                }}
              >
                <ListItemText primary={fileObj.name} />
                <IconButton onClick={() => handleRemoveFile(index)}>
                  <CloseIcon />
                </IconButton>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default TxtUpload;
